import { render } from "./login-page.vue?vue&type=template&id=467a1af8&ts=true"
import script from "./login-page.vue?vue&type=script&lang=ts"
export * from "./login-page.vue?vue&type=script&lang=ts"

import "./login-page.vue?vue&type=style&index=0&id=467a1af8&lang=css"

import exportComponent from "C:\\Projects\\OnlinePayments\\OnlinePayments\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__